import en from "./en.json";
import ar from "./ar.json";

export default { en, ar };